export default __webpack_public_path__ + "static/media/nextArrow.d422148a.svg";